module.exports = __webpack_public_path__ + "3ea17a61.png";